import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { ChartsModule } from 'ng2-charts';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { NgxEchartsModule } from 'ngx-echarts';
import * as echarts from 'echarts';
import { AgmCoreModule } from '@agm/core';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { FullCalendarModule } from '@fullcalendar/angular';
import { NzDatePickerModule, NzDividerModule, NzTableModule } from 'ng-zorro-antd';
import { DragDropModule } from '@angular/cdk/drag-drop';

import { environment } from '../../environments/environment';
import { UIModule } from '../ui/ui.module';
import { LayoutModule } from '../layout/layout.module';
import { BasePageComponent } from './base-page';


import { Page404Component } from './page-404';
import { MainPageComponentnt } from './main';
import { PageSignInComponent } from './sign-in';
import { PageSignUpComponent } from '../pages/sign-up';
import { ForgotPasswordComponent } from '../pages/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from '../pages/reset-password/reset-password.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgHttpLoaderModule } from 'ng-http-loader';
import { GeustComponent } from './guest/guest-page';

import { FoodMenuComponent } from './guest/food-menu';
import { Ng5SliderModule } from 'ng5-slider';
// import { NgxSliderModule } from '@angular-slider/ngx-slider';
//import { MatButtonModule, MatBottomSheetModule } from '@angular/material';
import { Ng2SearchPipeModule } from 'ng2-search-filter'
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { BottomSheetOverviewExampleSheet, BottomSheetOverviewReview, BottomSheetOverviewNote, BottomSheetAddon, BottomSheetCategory, BottomSheetKeyIngredients, BottomSheetFoodGuestLogin, BottomSheetGuestProfile, BottomSheetRatings ,BottomSheetDeclaimer, BottomAllegenList, AllergensChartDialog, UnsuitableBottomSheet, AllergensMsgDialog} from './guest/food-menu/food-menu.component';

import { BottomSheetOrderlistReview } from './guest/order-list/order-list.component';
import { A11yModule } from '@angular/cdk/a11y';
import { ClipboardModule } from '@angular/cdk/clipboard';

import { PortalModule } from '@angular/cdk/portal';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { CdkTableModule } from '@angular/cdk/table';
import { CdkTreeModule } from '@angular/cdk/tree';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatStepperModule } from '@angular/material/stepper';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSliderModule } from '@angular/material/slider';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { OverlayModule } from '@angular/cdk/overlay';
import { RestoPageComponent, BottomSheetOverviewCookies, BottomSheetOverviewOtp, BottomSheetProfileUpdate, BottomSheetUserLocation } from './resto-page/resto-page.component';
import { OrderMenuComponent, BottomSheetOverviewExampleSheets, BottomSheetGuestLogin, BottomSheetDishAddon, BottomSheetPayments, BottomSheetDishEditAddon } from './guest/order-menu';
import { OrderListComponent } from './guest/order-list';
import { UiSwitchModule } from 'ngx-toggle-switch';
// import { CartComponent } from './bottomnav/cart/cart.component';

import { BottommenuComponent } from './guest/bottommenu/bottommenu.component';
import { ProfileComponent, BottomSheetOverviewpreference, BottomSheetOverviewdietary, LogoutDialog, ShareLinkWithFreind } from './guest/profile/profile.component';
import { AllergyratingComponent } from './guest/allergyrating/allergyrating.component';
import { from } from 'rxjs';
import { AllorderreviewComponent } from './guest/allorderreview/allorderreview.component';
import { OrderDetailsComponent } from './guest/order-details/order-details.component';
import { TooltipModule } from 'ng2-tooltip-directive';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { TermsConditionComponent } from './terms-condition/terms-condition.component';
import { SubnavComponent } from './subnav/subnav.component';
import { BottomSheetConfirmLocation, BottomSheetuserCurrentLocation, UserLocationPermission, UsersrestoListComponent } from './guest/usersresto-list/usersresto-list.component';
import { EditProfileComponent } from './guest/edit-profile/edit-profile.component';
import { MyfriendsComponent } from './guest/myfriends/myfriends.component';
import { SharefriendsComponent, UserCheckPermission } from './guest/sharefriends';
import { UserprofileComponent, BottomSheetOverviewprofileallergens, BottomSheetOverviewprofiledietary } from './guest/userprofile/userprofile.component';
import { EditTasteprofileComponent } from './guest/edit-tasteprofile/edit-tasteprofile.component';
import { MypreferenceComponent } from './guest/mypreference/mypreference.component';
import { BottommenuRestoComponent } from './guest/bottommenu-resto/bottommenu-resto.component';
import { AgmDirectionModule } from 'agm-direction'; // agm-direction

import { NgOtpInputModule } from 'ng-otp-input';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { IvyCarouselModule } from 'angular-responsive-carousel';
import { guestUserEnableLocation, UserLocationComponent } from './guest/user-location/user-location.component';
import { AggregratorComponent, BottomSheetGuestConfirmLocation, BottomSheetGuestUserLocation, LocationPermission } from './guest/aggregrator/aggregrator.component';
import { UserGuestLocationComponent } from './guest/user-guest-location/user-guest-location.component';
import { PaymentSucessComponent } from './guest/payment-sucess/payment-sucess.component';
import { PaymentFailureComponent } from './guest/payment-failure/payment-failure.component';
import {MatFormFieldModule} from '@angular/material/form-field'
import {OutsideClickDirective} from './outside-click.directive';
import { SampleMenuComponent } from './guest/sample-menu/sample-menu.component'

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    RouterModule,
    NgHttpLoaderModule.forRoot(),
    ChartsModule,
    Ng5SliderModule,
    Ng2SearchPipeModule,
    NgxChartsModule,
    TooltipModule,
    UiSwitchModule,
    NgxEchartsModule.forRoot({
      echarts: { init: echarts.init }
    }),
    AgmCoreModule.forRoot({
      apiKey: environment.googleMapApiKey,
      libraries: ["places"],
    }),
    AgmDirectionModule,
    LeafletModule,
    FullCalendarModule,
    NzDatePickerModule,
    NzDividerModule,
    NzTableModule,
    DragDropModule,
    NgSelectModule,
    FormsModule,
    UIModule,
    MatButtonModule,
    MatBottomSheetModule,
    LayoutModule,
    MatListModule,
    A11yModule,
    ClipboardModule,
    CdkStepperModule,
    CdkTableModule,
    CdkTreeModule,
    DragDropModule,
    MatAutocompleteModule,
    MatBadgeModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatStepperModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatTreeModule,
    OverlayModule,
    PortalModule,
    ScrollingModule,
    NgOtpInputModule,
    NgbModule,
    IvyCarouselModule
  ],
  declarations: [
    BasePageComponent,
    GeustComponent,
    FoodMenuComponent,
    OrderMenuComponent,
    MainPageComponentnt,
    OrderListComponent,
    Page404Component,
    PageSignInComponent,
    PageSignUpComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    RestoPageComponent,
    BottomSheetOrderlistReview,
    BottomSheetOverviewCookies,
    BottomSheetOverviewOtp,
    BottomSheetCategory,
    BottomSheetOverviewExampleSheet,
    BottomSheetOverviewReview,
    BottomSheetOverviewpreference,
    ShareLinkWithFreind,
    BottomSheetOverviewdietary,
    BottomSheetOverviewExampleSheets,
    BottomSheetOverviewprofileallergens,
    BottomSheetOverviewprofiledietary,
    BottomSheetAddon,
    BottommenuComponent,
    BottomSheetKeyIngredients,
    BottomSheetGuestLogin,
    BottomSheetFoodGuestLogin,
    BottomSheetProfileUpdate,
    ProfileComponent,
    BottomSheetGuestProfile,
    LogoutDialog,
    AllergyratingComponent,
    AllorderreviewComponent,
    OrderDetailsComponent,
    PrivacyPolicyComponent,
    TermsConditionComponent,
    SubnavComponent,
    UsersrestoListComponent,
    EditProfileComponent,
    MyfriendsComponent,
    SharefriendsComponent,
    UserprofileComponent,
    EditTasteprofileComponent,
    MypreferenceComponent,
    BottommenuRestoComponent,
    BottomSheetDishAddon,
    BottomSheetDishEditAddon,
    BottomSheetUserLocation,
    UserLocationComponent,
    AggregratorComponent,
    BottomSheetuserCurrentLocation,
    UserGuestLocationComponent,
    BottomSheetConfirmLocation,
    BottomSheetGuestUserLocation,
    BottomSheetGuestConfirmLocation,
    BottomSheetPayments,
    LocationPermission,
    UserLocationPermission,
    UserCheckPermission,
    guestUserEnableLocation,
    BottomSheetRatings,
    BottomSheetDeclaimer,
    PaymentSucessComponent,
    PaymentFailureComponent,
    OutsideClickDirective,
    BottomAllegenList,
    AllergensChartDialog,
    UnsuitableBottomSheet,
    AllergensMsgDialog,
    SampleMenuComponent
  ],
  exports: [],
  entryComponents: [
    BottomSheetOrderlistReview,
    BottomSheetOverviewExampleSheet,
    BottomSheetOverviewReview,
    BottomSheetOverviewCookies,
    BottomSheetOverviewOtp,
    BottomSheetOverviewpreference,
    ShareLinkWithFreind,
    BottomSheetOverviewdietary,
    BottomSheetAddon,
    BottomSheetOverviewExampleSheets,
    BottomSheetOverviewprofileallergens,
    BottomSheetOverviewprofiledietary,
    BottomSheetKeyIngredients,
    BottomSheetGuestLogin,
    BottomSheetFoodGuestLogin,
    LogoutDialog,
    BottomSheetProfileUpdate,
    BottomSheetGuestProfile,
    BottomSheetDishAddon,
    BottomSheetDishEditAddon,
    BottomSheetUserLocation,
    BottomSheetuserCurrentLocation,
    BottomSheetConfirmLocation,
    BottomSheetGuestUserLocation,
    BottomSheetGuestConfirmLocation,
    BottomSheetPayments,
    LocationPermission,
    UserLocationPermission,
    UserCheckPermission,
    guestUserEnableLocation,
    BottomSheetRatings,
    BottomSheetDeclaimer,
    BottomAllegenList,
    AllergensChartDialog,
    UnsuitableBottomSheet,
    AllergensMsgDialog
  ],
  bootstrap: [FoodMenuComponent, OrderMenuComponent],
  providers: [
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { hasBackdrop: false } },
  ]
})
export class PagesModule { }
